<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    v-if="hasPermission"
    :id="slug"
    class="vs-sidebar--item"
    :class="[
      { 'vs-sidebar-item-active': activeLink },
      { 'disabled-item pointer-events-none': isDisabled },
    ]"
  >
    <router-link
      v-if="to"
      tabindex="-1"
      exact
      :class="[
        { 'small-padding': !icon },
        {
          'router-link-active': activeLink,
        },
      ]"
      :to="to"
      :target="target"
    >
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </router-link>

    <a
      v-else-if="href"
      :target="target"
      :href="href"
      tabindex="-1"
      :class="[{ 'small-padding': !icon }]"
    >
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </a>

    <a
      v-else
      href="#"
      tabindex="-1"
      :class="[{ 'small-padding': !icon }]"
      :target="target"
      @click="onClickFunction"
    >
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </a>
  </div>
</template>

<script>
import { hasAnyRoles } from "@/acl";
export default {
  name: "VNavMenuItem",
  props: {
    icon: {
      type: String,
      default: "",
    },
    iconSmall: {
      type: Boolean,
      default: false,
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
    href: {
      type: [String, null],
      default: "#",
    },
    to: {
      type: [String, Object, null],
      default: null,
    },
    slug: {
      type: String,
      default: null,
    },
    index: {
      type: [String, Number],
      default: null,
    },
    featherIcon: {
      type: Boolean,
      default: true,
    },
    target: {
      type: String,
      default: "_self",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    meta: {
      type: Object,
      default: null,
    },
    linkedUrls: {
      type: Array,
      default: null,
    },
    featured: {
      type: Boolean,
      default: false,
    },
    onClickFunction: {
      type: Function,
      default: null,
    },
  },
  computed: {
    activeLink() {
      const currentPath = this.$route.path;
      // if a url is open and it's one included in the NavMenuItem linked urls, we active it
      const isLinkedUrlsOpen = this.linkedUrls && this.linkedUrls.includes(currentPath);
      return (
        isLinkedUrlsOpen ||
        this.to == currentPath ||
        (this.$route.meta.parent == this.slug && this.to)
      );
    },
    hasPermission() {
      if (!this.meta || !this.meta.authorize) return true;
      return hasAnyRoles(this.meta.authorize);
    },
  },
};
</script>

<style lang="scss" scoped>
.small-padding {
  padding-left: 7px !important;
}
</style>
